// extracted by mini-css-extract-plugin
module.exports = {"campoPesquisa":"ParametrosConsulta_campoPesquisa__1JVoy","botao":"ParametrosConsulta_botao__4AuzB","icone":"ParametrosConsulta_icone__ezcTy"};